import { RnUsersVM } from '../../../services/rnapi2-service/models/models';

export class OrgRenameUserLoggedInConfig {
  type: string;
  verb: string;
  users: RnUsersVM[];
}
